"use client";

import { useState } from "react";
import arrowDownIcon from "@/assets/images/kbv-icon-arrow-down.svg";
import hotIcon from "@/assets/images/hot.svg";

const HOT_LEAGUE_ID = 1572;

export default function BetOKMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, id } = league || {};
  const isHotLeague = Number(id) === HOT_LEAGUE_ID;

  return (
    <div className="overflow-hidden transition-[max-height] duration-300 ease-in-out bg-[var(--theme-bg)] md:rounded-t-lg rounded-t-none md:rounded-b-lg rounded-b-none">
      <div
        className="bg-table-header-gradient flex items-center justify-between cursor-pointer border-b border-transparent p-2 md:p-4 rounded-b-none md:rounded-t-lg rounded-t-none transition-[border-radius] duration-300 ease-in-out md:py-2 md:px-2"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className="flex-1">
          <div className="rounded-t-lg w-full flex items-center md:gap-x-[5px] gap-x-1">
            <div className="w-[80%] max-w-[271px] md:w-[32%] md:min-w-[32%] md:max-w-[32%] shrink-0 flex items-center gap-1.5 min-w-0">
              <p
                className={`my-0 truncate capitalize md:text-md text-sm ${
                  isHotLeague
                    ? "font-bold text-[#FFDF58] drop-shadow-[0_0_6px_rgba(255,50,43,0.45)]"
                    : "text-white font-semi-bold"
                }`}
              >
                {name}
              </p>
              {isHotLeague && (
                <img src={hotIcon} alt="" className="shrink-0 h-[18px] w-auto" aria-hidden />
              )}
            </div>
            <div className="hidden md:flex flex-1 flex-row min-w-0 md:gap-x-[5px]">
              <div className="md:w-6 shrink-0" aria-hidden="true" />
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">Kèo chấp</p>
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">Tài/xỉu</p>
              <p className="flex-1 min-w-0 flex justify-center items-center text-white font-bold my-0">1X2</p>
            </div>
          </div>
        </div>
        <img src={arrowDownIcon} alt="" className={`kbv-v25-league-header-arrow w-5 h-5 -ml-5 transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} />
      </div>

      {/* Matches List */}
      <div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${isExpanded ? "max-h-[9999px]" : "max-h-0"}`}>
        {matches.map((match, idx) => render(match, idx))}
      </div>
    </div>
  );
}
